import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { Error } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  values: FormData
  children: () => ReactElement
  onSuccess: () => void
  onError?: (error: Error) => void
}

const UpdateCustomScriptRequest = ({
  id,
  values,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = TEST_CONFIG_SERVICE + '/custom_scripts/' + id

  return (
    <AuthenticatedDataRequest
      children={children}
      formData={values}
      isUrlEncoded
      method='patch'
      onError={onError}
      onSuccess={onSuccess}
      spinnerSize={0}
      url={url}
    />
  )
}

export default UpdateCustomScriptRequest
